var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 24,
    viewBox: "0 0 111 22",
    fill: "#EFDF00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.473 23.21C80.013-7.251 30.625-7.251.164 23.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.b873bb1bba0c2f3db85b0e8fa593216c.svg";
export { ForwardRef as ReactComponent };